import { useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "isoldit_cookie_notice_ok_v2";

export function CookieNotice() {
  const [show, setShow] = useState(() => localStorage.getItem(KEY) !== "1");
  if (!show) return null;
  const ok = () => { localStorage.setItem(KEY, "1"); setShow(false); };
  return (
    <div data-testid="cookie-notice" className="rise fixed inset-x-3 bottom-3 z-50 mx-auto flex max-w-2xl flex-col gap-3 rounded-2xl border border-white/10 bg-[#173742]/95 p-4 text-sm text-slate-200 shadow-2xl backdrop-blur-xl sm:flex-row sm:items-center">
      <Cookie className="hidden h-6 w-6 shrink-0 text-[#d4f253] sm:block" />
      <p className="flex-1">We use an essential cookie to keep you logged in, and Google uses cookies to show ads that keep ISoldIt free. <Link to="/privacy" data-testid="cookie-notice-privacy-link" className="font-semibold text-[#d4f253] hover:underline">Privacy Policy</Link></p>
      <button data-testid="cookie-notice-ok-btn" onClick={ok} className="btn-lime shrink-0 px-5 py-2.5 text-sm">Got it</button>
    </div>
  );
}
